import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getOrderClaimForm, setOrderClaimForm } from 'domains/order/Order.store';
import { getTextMandatory } from 'pages/MyOrdersPage/OrderClaims/claimForm.utils';
import { getReasonOption, getReasonsForFormType } from 'pages/MyOrdersPage/OrderClaims/claimFormData';
import { Flex, Select, Text } from 'UI';

const ReasonSection = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const claimForm = useSelector(getOrderClaimForm);
  const availableReasons = getReasonsForFormType(t, claimForm.formType);
  const reasonOptions = getReasonOption(t).get(claimForm.reason);

  useEffect(() => {
    if (claimForm.reason !== '' && !availableReasons.some((r) => r.value === claimForm.reason)) {
      dispatch(setOrderClaimForm({ ...claimForm, reason: '', option: undefined }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [claimForm.formType, claimForm.referenceNumberOrdered]);

  return (
    <>
      <Text type="heading3" disableGutter noWrap>
        {t('my_orders.details.return_request.reason', 'Reason')}
      </Text>
      <Flex gap={50}>
        <Flex direction={'column'} maxWidth={450}>
          <Text type="base" noWrap>
            {getTextMandatory(t('my_orders.details.return_request.reason', 'Reason'), 'mandatory')}
          </Text>
          <Select
            value={claimForm.reason !== '' ? claimForm.reason : undefined}
            onChange={(reason: string) => {
              dispatch(
                setOrderClaimForm({
                  ...claimForm,
                  reason,
                  option: undefined,
                }),
              );
            }}
            options={availableReasons}
            bordered
            placeholder={t('common.action.select', 'Select')}
          />
        </Flex>
        {reasonOptions && (
          <Flex direction={'column'} maxWidth={200}>
            <Text type="base" noWrap>
              {getTextMandatory(t('common.option', 'Option'), 'mandatory')}
            </Text>
            <Select
              value={claimForm.option}
              onChange={(option: string) => {
                dispatch(
                  setOrderClaimForm({
                    ...claimForm,
                    option,
                  }),
                );
              }}
              options={reasonOptions}
              bordered
              placeholder={t('common.action.select', 'Select')}
            />
          </Flex>
        )}
      </Flex>
    </>
  );
};

export default ReasonSection;
